import { ScrollableArea } from "@nova/component-scrollable-area"
import { zIndex } from "@nova/constants"
import { SegmentedControl } from "panels/content/top-bar/TODO-put-in-package/SegmentedControl"
import { FC, useEffect, useState } from "react"
import { useIsEditor } from "tools/hooks/useIsEditor"

const genericInspectorPanelTabs = ["Layer", "Data"] as const

export function getGenericInspectorPanelBody({
    LayerComponent,
    DataComponent,
    isScrollable = false,
}: {
    LayerComponent?: FC<{ id: string }>
    DataComponent?: FC<{ id: string }>
    isScrollable?: boolean
}) {
    const GenericInspectorPanelBody = ({ id }: { id: string }) => {
        const isEditor = useIsEditor()
        const [tab, setTab] = useState<(typeof genericInspectorPanelTabs)[number]>(
            genericInspectorPanelTabs[0]
        )
        useEffect(() => {
            setTab(genericInspectorPanelTabs[0])
        }, [id])
        if (!isEditor) return !!DataComponent ? <DataComponent id={id} /> : null
        const ActiveComponent = tab === "Layer" ? LayerComponent : DataComponent
        return (
            <div className="flex flex-col gap-1 min-h-0 shrink">
                <div className="px-4 mb-1">
                    <SegmentedControl
                        segments={genericInspectorPanelTabs}
                        defaultSelectedIndex={genericInspectorPanelTabs.findIndex((t) => t === tab)}
                        onChange={(i) => setTab(genericInspectorPanelTabs[i])}
                        zIndex={zIndex.InspectorPanel + 10}
                    />
                </div>
                {ActiveComponent && (
                    <>
                        {isScrollable ? (
                            <ScrollableArea shouldPreventScrollbarShifting>
                                <ActiveComponent id={id} />
                            </ScrollableArea>
                        ) : (
                            <ActiveComponent id={id} />
                        )}
                    </>
                )}
            </div>
        )
    }
    return GenericInspectorPanelBody
}

export function getGenericMockedInspectorPanelBody({ RenderComponent }: { RenderComponent: FC }) {
    const GenericMockedInspectorPanelBody = () => {
        return (
            <div className="flex flex-col gap-1 shrink">
                <RenderComponent />
            </div>
        )
    }
    return GenericMockedInspectorPanelBody
}
